import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import { gsap } from "gsap"
import { Logo } from '../Icons'

import "./Intro.scss"

const Intro = ({ handleIntroPlaying }) => {
  const [ isLoading, setIsLoading ] = useState(true)
  const refIntro = useRef()
  const refLogo = useRef()
  const refOverlay = useRef()

  useEffect(() =>{
    const tl = gsap.timeline();
    setIsLoading(false)

    if (refIntro) {
      tl.from(refLogo.current, { opacity: 0, y: 40, duration: 2 })
      tl.to(refIntro.current, { opacity: 0, duration: 1, onComplete: () => handleIntroPlaying() })
      // tl.to(refLogo.current, { opacity: 0, duration: 1 }, '-=1.25')
    }
  }, [isLoading])

  return (
    <section ref={refIntro} className={`intro intro--isIntro`}>
      {!isLoading ?
        <div className="intro__inner">
          <div className="intro__header">
            <div ref={refLogo}><Logo className="intro__logo" /></div>
          </div>
        </div>
      : null }
      <div ref={refOverlay} className="intro__overlay"></div>
    </section>
  )
}

Intro.propTypes = {
  handleIntroPlaying: PropTypes.func.isRequired,
}


export default Intro